var AnnouncementBar = {

    init:function(){
        console.log("INIT ANNONCEMENT BAR");
        $("#announcement__bar--container").slick({
            infinite : true,
            arrows: false,
            dots: false,
            autoplay: true,
            duration: 1500,
            vertical: true,
        });
    },
}

$(window).on("load", function(){
    if($("#announcement__bar--container").length){
        AnnouncementBar.init();
    }
})